import { useState, useEffect } from 'react';
import { ChevronDown, ChevronUp, HelpCircle, ArrowLeft, Search, RefreshCw } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Default FAQ data (fallback)
const DEFAULT_FAQ = [
  {
    category: "Teori Sınavı Hakkında",
    questions: [
      {
        q: "İsveç ehliyet sınavı kaç soru?",
        a: "İsveç ehliyet teorik sınavı (Teoriprov) 70 sorudan oluşur. Geçmek için en az 52 soruyu (%74) doğru cevaplamanız gerekir. Sınav süresi 50 dakikadır ve Türkçe dahil 13 farklı dilde yapılabilir."
      },
      {
        q: "Ehliyet sınavı Türkçe yapılabilir mi?",
        a: "Evet! İsveç'te Trafikverket teorik sınavı (teoriprov) Türkçe dahil 13 farklı dilde yapılabilmektedir. Sınav merkezinde tercüman eşliğinde değil, bilgisayarda Türkçe sorular çözersiniz."
      },
      {
        q: "Teori sınavından kaç kere kalınabilir?",
        a: "İsveç'te teori sınavından kalma sayısı sınırsızdır. Ancak her sınav için yeniden ücret ödemeniz gerekir (yaklaşık 400 SEK). Ehliyet.nu ile çalışarak ilk seferde geçme şansınızı %95'e çıkarabilirsiniz!"
      },
      {
        q: "Teori sınavı hangi konuları kapsıyor?",
        a: "Teori sınavı şu konuları kapsar: Trafik kuralları ve işaretleri, yol güvenliği, araç tekniği, çevre ve yakıt tasarrufu, ilk yardım, alkol ve uyuşturucu etkileri. Tüm bu konular Ehliyet.nu'de Türkçe olarak mevcuttur."
      },
      {
        q: "Teori sınavı ne kadar sürüyor?",
        a: "Teori sınavı için 50 dakika süre verilir. 70 soruyu bu sürede cevaplamanız gerekir. Genellikle 30-40 dakikada bitirebilirsiniz."
      }
    ]
  },
  {
    category: "İsveç'te Ehliyet Alma",
    questions: [
      {
        q: "İsveç'te ehliyet almak ne kadar sürer?",
        a: "İsveç'te ehliyet alma süreci ortalama 3-6 ay sürer. Bu süre teorik ve pratik eğitim, sınav randevuları ve kişisel çalışma temponuza bağlıdır. Yoğun çalışarak 2 ayda da tamamlayabilirsiniz."
      },
      {
        q: "İsveç'te ehliyet almanın toplam maliyeti nedir?",
        a: "2025 yılında İsveç'te ehliyet almanın toplam maliyeti 15.000-25.000 SEK arasındadır. Bu maliyet: Teori sınavı (400 SEK), pratik sınav (1000 SEK), sürüş dersleri (10.000-20.000 SEK), Risk 1-2 kursları (2000-3000 SEK) içerir."
      },
      {
        q: "Körkortstillstånd (ehliyet izni) nasıl alınır?",
        a: "Körkortstillstånd almak için Trafikverket'e başvuru yapmanız gerekir. Online başvuru yapabilirsiniz. Göz testi ve sağlık beyanı gerekir. İzin 5 yıl geçerlidir ve teorik sınavdan önce almanız şarttır."
      },
      {
        q: "Risk 1 ve Risk 2 kursu nedir?",
        a: "Risk 1 (Introduktionskurs): Alkol, uyuşturucu ve yorgunluğun sürüşe etkileri. Zorunlu, teorik sınavdan önce alınmalı. Risk 2 (Riskutbildning): Kaygan yolda sürüş pratiği. Pratik sınavdan önce alınmalı."
      },
      {
        q: "Türkiye ehliyetimi İsveç'te kullanabilir miyim?",
        a: "Türkiye ehliyeti İsveç'te 1 yıl süreyle geçerlidir (kalıcı oturumunuz varsa). Sonrasında İsveç ehliyetine çevirmeniz gerekir. Teori ve pratik sınavlarını geçmeniz şarttır."
      }
    ]
  },
  {
    category: "Ehliyet.nu Hakkında",
    questions: [
      {
        q: "Ücretsiz ehliyet soruları nereden çözebilirim?",
        a: "Ehliyet.nu'de 30 ücretsiz ehliyet sorusu çözebilirsiniz. Hiç kayıt olmadan, hemen başlayabilirsiniz. Premium üyelikle 2000+ soruya ve tüm özelliklere erişebilirsiniz."
      },
      {
        q: "Premium üyelik ne kadar?",
        a: "Premium üyelik tek seferlik 249 SEK'tir. Aylık ödeme yok, sınırsız süre erişim. 2000+ soru, gerçek sınav simülasyonu, ilerleme takibi ve Türkçe açıklamalar dahil."
      },
      {
        q: "Sorular gerçek sınav sorularıyla aynı mı?",
        a: "Sorularımız Trafikverket'in resmi müfredatına uygun hazırlanmıştır. Gerçek sınav formatında (70 soru, 50 dakika) pratik yapabilirsiniz. Kullanıcılarımızın %95'i ilk seferde geçiyor!"
      },
      {
        q: "Mobil cihazdan çalışabilir miyim?",
        a: "Evet! Ehliyet.nu tüm cihazlarda çalışır - telefon, tablet ve bilgisayar. İnternete bağlı olduğunuz her yerden çalışabilirsiniz."
      }
    ]
  },
  {
    category: "Sınav Günü",
    questions: [
      {
        q: "Teori sınavına ne götürmeliyim?",
        a: "Teori sınavına kimlik belgesi (pasaport veya İsveç kimliği) götürmeniz yeterlidir. Kalem, kağıt veya hesap makinesi götürmenize gerek yok - her şey bilgisayarda."
      },
      {
        q: "Sınav sonucu ne zaman açıklanır?",
        a: "Teori sınavı sonucu sınav biter bitmez ekranda görüntülenir. Anında geçip geçmediğinizi öğrenirsiniz. Detaylı sonuç raporu da verilir."
      },
      {
        q: "Sınavda kopya çekilebilir mi?",
        a: "Hayır, sınav salonunda sıkı güvenlik önlemleri var. Telefon ve elektronik cihazlar yasak. Her adayın soruları farklı sırada gelir. Kopya girişimi sınavın iptaliyle sonuçlanır."
      }
    ]
  }
];

export default function SSS() {
  const [searchTerm, setSearchTerm] = useState('');
  const [openQuestions, setOpenQuestions] = useState({});
  const [faqData, setFaqData] = useState(DEFAULT_FAQ);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFAQ();
  }, []);

  const fetchFAQ = async () => {
    try {
      const res = await fetch(`${API}/faq`);
      const data = await res.json();
      if (data.categories && data.categories.length > 0) {
        setFaqData(data.categories);
      }
    } catch (err) {
      console.log('Using default FAQ data');
    } finally {
      setLoading(false);
    }
  };

  const toggleQuestion = (categoryIdx, questionIdx) => {
    const key = `${categoryIdx}-${questionIdx}`;
    setOpenQuestions(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const filteredData = faqData.map(category => ({
    ...category,
    questions: category.questions.filter(
      q => q.q.toLowerCase().includes(searchTerm.toLowerCase()) ||
           q.a.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })).filter(category => category.questions.length > 0);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center">
        <RefreshCw className="w-12 h-12 text-purple-400 animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      <div className="bg-black/20 border-b border-white/10">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <a href="/" className="inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors mb-4">
            <ArrowLeft className="w-5 h-5" />
            <span>Ana Sayfa</span>
          </a>
          
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl flex items-center justify-center">
              <HelpCircle className="w-10 h-10 text-white" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-bold text-white">Sık Sorulan Sorular</h1>
              <p className="text-white/70">İsveç ehliyet sınavı hakkında merak ettikleriniz</p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="relative max-w-xl mx-auto mb-12">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
          <input
            type="text"
            placeholder="Soru ara... (örn: kaç soru, türkçe, maliyet)"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-12 pr-4 py-4 bg-white/10 border border-white/20 rounded-xl text-white placeholder:text-white/50 focus:outline-none focus:ring-2 focus:ring-amber-500"
          />
        </div>

        <div className="space-y-8">
          {filteredData.map((category, categoryIdx) => (
            <div key={categoryIdx} className="bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 overflow-hidden">
              <h2 className="text-xl font-bold text-white px-6 py-4 bg-white/5 border-b border-white/10">
                {category.category}
              </h2>
              
              <div className="divide-y divide-white/10">
                {category.questions.map((item, questionIdx) => {
                  const isOpen = openQuestions[`${categoryIdx}-${questionIdx}`];
                  return (
                    <div key={questionIdx} className="group">
                      <button
                        onClick={() => toggleQuestion(categoryIdx, questionIdx)}
                        className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-white/5 transition-colors"
                      >
                        <h3 className="text-lg font-semibold text-white pr-4">{item.q}</h3>
                        {isOpen ? (
                          <ChevronUp className="w-5 h-5 text-amber-400 flex-shrink-0" />
                        ) : (
                          <ChevronDown className="w-5 h-5 text-white/50 group-hover:text-amber-400 flex-shrink-0" />
                        )}
                      </button>
                      
                      {isOpen && (
                        <div className="px-6 pb-4">
                          <p className="text-white/80 leading-relaxed">{item.a}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-gradient-to-r from-amber-500/20 to-orange-500/20 rounded-2xl p-8 border border-amber-500/30">
            <h2 className="text-2xl font-bold text-white mb-4">Hala sorunuz mu var?</h2>
            <p className="text-white/70 mb-6">Ücretsiz deneme ile başlayın veya Premium üyelikle tüm sorulara erişin!</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => {
                  window.location.href = '/#quiz-section';
                }}
                className="px-8 py-3 bg-gradient-to-r from-emerald-500 to-teal-600 text-white font-bold rounded-xl hover:shadow-lg transition-all hover:scale-105"
              >
                Ücretsiz Dene
              </button>
              <button
                onClick={() => {
                  window.location.href = '/payment';
                }}
                className="px-8 py-3 bg-gradient-to-r from-amber-500 to-orange-600 text-white font-bold rounded-xl hover:shadow-lg transition-all hover:scale-105"
              >
                Premium Ol
              </button>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center text-white/50 text-sm">
          <p>
            İsveç ehliyet sınavı (teoriprov) hakkında daha fazla bilgi için{' '}
            <a href="/blog" className="text-amber-400 hover:underline">blog sayfamızı</a> ziyaret edin.
          </p>
        </div>
      </div>
    </div>
  );
}
